import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import Emitter from '@utils/eventEmitter'

export const getReportList = createAsyncThunk(
  'GET_REPORT_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/report`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data: response,
    }
  }
)

export const updateReport = createAsyncThunk(
  'UPDATE_REPORT',
  async (data) => {
    let options = {
      method: 'PUT',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/report/${data.reportId}`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const getReportWithExcel = createAsyncThunk(
  'GET_REPORT_WITH_EXCEL',
  async (data) => {
    let options = {
      method: 'POST',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/report/excel`,
      data,
      responseType: 'blob',
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data: response,
      param: data,
    }
  }
)

const reportAdminSlice = createSlice({
  name: 'reportAdmin',
  initialState: {
    isLoading: false,
    reportList: [],
  },
  reducers: {
    clearReportList: (state) => {
      state.reportList = []
    },
  },
  extraReducers: {
    [getReportList.pending]: (state) => {
      state.isLoading = true
    },
    [getReportList.rejected]: (state) => {
      state.isLoading = false
    },
    [getReportList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.reportList = payload.data
    },
    [updateReport.fulfilled]: (state, { payload }) => {

    },
    [getReportWithExcel.fulfilled]: (state, { payload }) => {
      const url = window.URL.createObjectURL(new Blob([payload.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `report_excel[${payload.param.startDate}-${payload.param.endDate}].xlsx`) //or any
      // other extension
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        link.parentNode.removeChild(link)
      })

      Emitter.emit('SHOW_MESSAGE', {
        text: `파일이 다운로드되었습니다.`
      })
    }
  }
})

export const { clearReportList } = reportAdminSlice.actions

export default reportAdminSlice.reducer